import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studySiteManagementServices = {
  //Site Column
  addNewStudySiteColumn,
  updateStudySiteColumnData,
  deleteStudySiteColumnData,
  softDeleteRestoreStudySiteColumn,
  getStudySiteColumnData,
  
  //Site Row
  addNewStudySiteRow,
  updateStudySiteRowData,
  deleteStudySiteRowData,
  softDeleteRestoreStudySiteRow,
  getStudySiteRowData,
  getStudySiteBasedonAccess,
  getSiteRandomizable,
  getTotalSite,
  getSingleSiteData,
  getHeighestVersionSiteRowHistory,
  getStudySiteAuditTrials
};

// Get Study Site Column
async function getStudySiteColumnData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySiteColumnData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySiteColumnData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study Site Based on Access
async function getStudySiteBasedonAccess(studyId, mode) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySiteBasedonAccess/${studyId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Study Site Randomizable
async function getSiteRandomizable(studyId, mode) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSiteRandomizable/${studyId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Total Site
async function getTotalSite(studyId, mode) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getTotalSite/${studyId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Single Site Data
async function getSingleSiteData(studyId, siteId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSingleSiteData/${studyId}/${siteId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Add New Study Site Column
async function addNewStudySiteColumn(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudySiteColumn`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Site Column
async function updateStudySiteColumnData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudySiteColumnData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Site Column
async function softDeleteRestoreStudySiteColumn(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudySiteColumn`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Site Column
async function deleteStudySiteColumnData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudySiteColumnData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Site Row
async function getStudySiteRowData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySiteRowData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySiteRowData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Site Row
async function addNewStudySiteRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudySiteRow`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Site Row
async function updateStudySiteRowData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudySiteRowData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Site Row
async function softDeleteRestoreStudySiteRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudySiteRow`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Site Row
async function deleteStudySiteRowData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudySiteRowData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Site Row Heighest version
async function getHeighestVersionSiteRowHistory(studyId, siteId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getHeighestVersionSiteRowHistory/${studyId}/${siteId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Study Site Row Audit Trial
async function getStudySiteAuditTrials(studyId, siteId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySiteAuditTrials/${studyId}/${siteId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}